/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPINDUSTRYSECTOR = {
    PrivateSector: '01',
    PublicSector: '02',
    NotApplicable: '03',
    Other: '04'
} as const;
export type IAPINDUSTRYSECTOR = typeof IAPINDUSTRYSECTOR[keyof typeof IAPINDUSTRYSECTOR];


export function IAPINDUSTRYSECTORFromJSON(json: any): IAPINDUSTRYSECTOR {
    return IAPINDUSTRYSECTORFromJSONTyped(json, false);
}

export function IAPINDUSTRYSECTORFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPINDUSTRYSECTOR {
    return json as IAPINDUSTRYSECTOR;
}

export function IAPINDUSTRYSECTORToJSON(value?: IAPINDUSTRYSECTOR | null): any {
    return value as any;
}

